import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const TextFieldStyled = withStyles((theme) => ({
  root: {
    '& label': {
      '&.MuiFormLabel-root': {
        color: theme.palette.form.labelColor,
        fontSize: theme.typography.pxToRem(12),
        paddingLeft: 16,
      },
      '&.MuiFormLabel-filled': {
        color: theme.palette.form.labelFilledColor,
        fontSize: theme.typography.pxToRem(13),
        background: 'inherit',
        paddingLeft: 0,
      },
      '&.Mui-focused': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(13),
        background: 'inherit',
        paddingLeft: 0,
      },
      '&.Mui-error': {
        color: theme.palette.error.main,
      },
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: theme.palette.form.border,
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: theme.palette.form.border,
    },
    '& .MuiInput-root': {
      '& .MuiInputBase-input': {
        fontSize: theme.typography.pxToRem(14),
        padding: '6px 30px 6px 16px',
      },
    },
    '& .MuiFormHelperText-root': {
      fontSize: theme.typography.pxToRem(12),
      marginLeft: 16,
    },
  },
}))(TextField);

export default TextFieldStyled;
